<template>
  <div>
    <div class="ui warning icon message" v-if="unconfirmedOrders.length>0 && $router.name != 'waiting-for-delivery-view'">
      <i class="info circle icon"></i>
      <div class="content">
        <div class="header">
          Uzmanību!
        </div>
        <p>Lūdzu apstipriniet rītdienas BIOveikala Autoship pasūtījumu <b>#{{unconfirmedOrders[0].id}}</b> uz adresi <b>{{unconfirmedOrders[0].address}}</b></p>
        <div class="ui custom_brown button"  tabindex="0" >
          <div class="visible content" @click="confirmOrderDelivery(unconfirmedOrders[0])">Apstiprināt rītdienas piegādi</div>
        </div>
      </div>
    </div>
    <div class="ui positive icon message" v-if="order.confirmed && order.status >= 3">
      <i class="checkmark icon"></i>
      <div class="content">
        <div class="header">
          Paldies!
        </div>
        <p>BIOveikala Autoship pasūtījums tiks piegādāts <b>{{order.delivery_date}}</b></p>

      </div>
    </div>
</div>
</template>

<script>
export default {

  data() {
      return {
          order: {}
      }
  },
  computed: {
    unconfirmedOrders() {
      return this.$store.state.orderStore.unconfirmed
    },
    user() {
      return this.$store.state.userStore.user
    }
  },

  watch: {
    '$route.params': 'checkForUncofirmedOrders',
  },


  methods: {
    checkForUncofirmedOrders(){
      //if user is not logged in then skip (general principle)
      if(this.user && this.user.role > 0) {
        this.order = {}
        this.$store.dispatch('loadUnconfirmedOrders')
      }
    },

    confirmOrderDelivery(item){
      item = JSON.parse(JSON.stringify(item));
      item.confirmed =  1;

      this.$store.dispatch('updateOrder', item).then((response) => {

        this.order = response.data.order;
        this.$store.dispatch('loadUnconfirmedOrders'); //to keep order object as is
      }).catch((error) => {
        this.order = {};
        console.error('Order was not confirmed ')
      });

    }
  }

}
</script>



// WEBPACK FOOTER //
// Notifications.vue?5c2a9a52